<header>
  <a href="/">
    <img src="/assets/logo-dark.svg" class="light-only" width="225" [alt]="title" />
    <img src="/assets/logo.svg" class="dark-only" width="225" [alt]="title" />
  </a>
  <h2 [ngClass]="{ 'no-mg': currentDeviceService && currentDeviceService.isLandscape }">
    <b>{{ title }}</b>
  </h2>
  @if (subtitle) {
    <p class="color-gray" style="text-wrap: nowrap">{{ subtitle }}</p>
  }
</header>
